module.exports = {
    resourceBaseUrl: "http://official.assets.zwhlgroup.com",
};
